import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { FaPencilAlt, FaCaretDown } from 'react-icons/fa';
import Header from '../../../../../../header/header';
import Navvbar from '../../../../../../header/Navvbar';
import Footer from "../../../../../../footer.js";
import Swal from 'sweetalert2';
import Sidebar from '../../../../../../Sidebar.js';
import './AddShippingType.css';

const ShippingAdd = () => {
  const navigate = useNavigate();

  const [addedBy, setAddedBy] = useState('');
  const [formData, setFormData] = useState({
    company: 'Royal mail',
    service: '',
    usuallyDeparts: '',
    outboundDays: 0,
    inboundDays: 0,
    price: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const storedUserId = localStorage.getItem('userLabId');

    if (storedUserId) {
      setAddedBy(storedUserId);
    } else {
      setError('User information not found. Please log in again.');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === 'outboundDays' || name === 'inboundDays' || name === 'price') {
      updatedValue = value === '' ? null : Number(value);
    }

    setFormData(prev => ({ ...prev, [name]: updatedValue }));
    setError('');
  };

  const handleSave = async () => {
    if (!addedBy) {
      Swal.fire({
        title: 'Error!',
        text: 'User information not found. Please log in again.',
        icon: 'error',
        confirmButtonColor: '#004aad'
      });
      return;
    }

    if (
      !formData.service ||
      formData.outboundDays == null ||
      formData.inboundDays == null
    ) {
      Swal.fire({
        title: 'Missing Fields',
        text: 'Please fill all required fields (Service, Outbound & Inbound Days)',
        icon: 'warning',
        confirmButtonColor: '#004aad'
      });
      return;
    }

    setLoading(true);
    setError('');

    try {
      const body = {
        ...formData,
        usuallyDeparts: formData.usuallyDeparts || '',
        addedBy: addedBy,
      };

      const res = await fetch('https://hms.backend.hiragroupcloud.com/api/shipping/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (data.success) {
        Swal.fire({
          title: 'Success!',
          text: 'Shipping Type Added Successfully!',
          icon: 'success',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false
        });

        setTimeout(() => {
          navigate('/caseSetting');
        }, 2000);
      } else {
        Swal.fire({
          title: 'Error',
          text: data.message || 'Error saving shipping type',
          icon: 'error',
          confirmButtonColor: '#004aad'
        });
      }
    } catch (err) {
      Swal.fire({
        title: 'Network Error',
        text: 'Failed to save shipping type. Please check your connection and try again.',
        icon: 'error',
        confirmButtonColor: '#004aad'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="sa-header-wrap">
        <Header />
        <Navvbar />
      </div>

      <div className="sa-container">
        <div className="row sa-row">
          {/* Sidebar */}
          <div className="col-md-2 sa-sidebar">
            <Sidebar />
          </div>

          {/* Main Form Area */}
          <div className="col-md-10 sa-main">
            <div className="sa-main-inner">
              <h1 className="sa-page-title">Add Shipping Type</h1>
              <h2 className="sa-section-title">Shipping Type Details</h2>

              <div className="sa-form-box">
                {/* Company */}
                <div className="sa-row-field">
                  <label className="sa-label">
                    Company <span className="sa-required">*</span>
                  </label>
                  <div className="sa-select-wrap">
                    <select
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="sa-select"
                    >
                      <option value="Royal mail">Royal mail</option>
                      <option value="Uber">Uber</option>
                      <option value="Local Driver">Local Driver</option>
                      <option value="Daewoo">Daewoo</option>
                      <option value="Tcs">Tcs</option>
                      <option value="Bykea">Bykea</option>
                    </select>
                    <FaCaretDown className="sa-caret" />
                  </div>
                </div>

                {/* Service */}
                <div className="sa-row-field">
                  <label className="sa-label">
                    Service <span className="sa-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    placeholder="Enter service name"
                    className="sa-input"
                  />
                </div>

                {/* Usually Departs */}
                <div className="sa-row-field">
                  <label className="sa-label">Usually Departs</label>
                  <input
                    type="text"
                    name="usuallyDeparts"
                    value={formData.usuallyDeparts}
                    onChange={handleChange}
                    placeholder="e.g., 10:00 AM"
                    className="sa-input"
                  />
                </div>

                {/* Outbound Transit */}
                <div className="sa-row-field sa-row-small-gap">
                  <label className="sa-label">
                    Outbound Transit <span className="sa-required">*</span>
                  </label>
                  <input
                    type="number"
                    name="outboundDays"
                    value={formData.outboundDays ?? ''}
                    onChange={handleChange}
                    className="sa-input-num"
                    min="0"
                    step="1"
                  />
                  <span className="sa-hint">Days</span>
                </div>

                {/* Inbound Transit Days */}
                <div className="sa-row-field sa-row-small-gap sa-row-20">
                  <label className="sa-label">
                    Inbound Transit Days <span className="sa-required">*</span>
                  </label>
                  <input
                    type="number"
                    name="inboundDays"
                    value={formData.inboundDays ?? ''}
                    onChange={handleChange}
                    className="sa-input-num"
                    min="0"
                    step="1"
                  />
                </div>

                {/* Price – Optional */}
                <div className="sa-row-field sa-row-small-gap sa-row-20">
                  <label className="sa-label">Price</label>
                  <input
                    type="number"
                    name="price"
                    value={formData.price ?? ''}
                    onChange={handleChange}
                    step="0.01"
                    placeholder="0.00"
                    className="sa-input-num sa-input-price"
                    min="0"
                  />
                  <span className="sa-hint">(Optional)</span>
                </div>

                {/* Save Button */}
                <div className="sa-save-wrap">
                  <button
                    onClick={handleSave}
                    disabled={loading || !addedBy}
                    className={`sa-save-btn ${!addedBy ? 'sa-btn-off' : ''} ${loading ? 'sa-btn-loading' : ''}`}
                  >
                    <FaPencilAlt /> {loading ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="sa-footer-wrap">
        <Footer />
      </div>
    </>
  );
};

export default ShippingAdd;